// Cálculos defensivos client-side pra fallback de gaps no backend (ver
// API-SPEC §gaps): `failureRate` vem >100%, `ctr` às vezes vem 0 mesmo
// com clicks, etc.

export function correctFailureRate(failures: number, sends: number): number {
    const total = (sends || 0) + (failures || 0);
    if (!total) return 0;
    return Math.min(100, (failures / total) * 100);
}

export function calcCtr(clicks: number, sends: number): number {
    if (!sends) return 0;
    return Math.min(100, (clicks / sends) * 100);
}

export function calcRpm(revenue: number, sends: number): number {
    if (!sends) return 0;
    return (revenue / sends) * 1000;
}
